<template>
  <div class="label-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="top-box">
          <div class="title">用户信息标签组—宝宝月龄：</div>
          <div class="btn" @click="handleLabelModal('add')">新建画像标签</div>
        </div>
        <!-- <span class="tip">轮播图最多上传5张</span> -->
        <el-table
          :data="labelList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            prop="userid"
            align="center"
            label="画像标签名"
          ></el-table-column>
          <el-table-column
            prop="userid"
            align="center"
            label="标签应用类型"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: space-between;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteLabel(scope.row.id)"
                >
                  详情
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleLabelModal('edit', scope.row)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deleteLabel(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addLabelShow"
      class="dialog"
      width="600px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        {{ type === "edit" ? "编辑" : "新增" }}画像标签
      </div>
      <el-form
        ref="form"
        :model="addLabelForm"
        class="label-form"
        v-if="showType === 1"
        label-width="auto"
      >
        <el-form-item label="画像标签:" prop="sort" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入名称"
            class="add-renovation-input"
            style="width: 260px"
            v-model="addLabelForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="标签应用类型:" prop="sort" class="form-item">
          <el-select
            size="mini"
            style="width: 260px"
            class="add-renovation-input"
            v-model="addLabelForm.name"
            placeholder="请选择"
          >
            <el-option
              v-for="item in labelTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        ref="form"
        :model="addLabelForm"
        class="label-form"
        v-if="showType === 2"
        label-width="auto"
      >
        <el-form-item label="画像标签：" prop="sort" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入名称"
            class="add-renovation-input"
            style="width: 260px"
            v-model="addLabelForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="规则：" prop="sort" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入"
            class="add-renovation-input"
            style="width: 90px"
            v-model="addLabelForm.name"
          ></el-input>
          <span>天内登录</span>
          <el-input
            size="mini"
            placeholder="请输入"
            class="add-renovation-input"
            style="width: 90px"
            v-model="addLabelForm.name"
          ></el-input>
          <span>次</span>
        </el-form-item>
        <el-form-item label="标签应用类型：" prop="sort" class="form-item">
          <el-input
            size="mini"
            placeholder="请输入名称"
            class="add-renovation-input"
            style="width: 260px"
            v-model="addLabelForm.name"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addLabelShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleLabel"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 修改排序弹窗 -->
    <el-dialog title="更改排序" width="400px" :visible.sync="sortShow">
      <el-form label-width="60px" size="mini" ref="editSort" inline-message>
        <el-form-item label="排序：" prop="tableData" style="margin-top: 15px">
          <el-input v-model="currentSort" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="sortShow = false"
          >取 消</el-button
        >
        <el-button class="btn confirm-btn" @click="saveSort">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'label',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '画像标签'
      },
      labelList: [], // 轮播列表
      sortShow: false,
      currentSort: 0,
      addLabelForm: {
        name: '',
      },
      labelTypeList: [],
      addLabelShow: false,
      labelId: null,
      showType: 1,
      type: ''
    };
  },
  mounted() {
    // 获取列表
    this.getLabelList();
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取轮播列表
    getLabelList() {
      this.loading++;
      this.httpGet(this.$root.getServicerList, {}).then(
        (res) => {
          this.loading--;
          this.labelList = res;
          // this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 编辑轮播弹窗
    handleLabelModal(type, rowData) {
      this.type = type;
      if (type === 'edit') {
        this.labelId = rowData.id;
        this.addLabelForm = {
          name: rowData.pic,
        };
      } else {
        this.addLabelForm = {
          name: ''
        };
        this.$refs.form && this.$refs.form.clearValidate();
      }
      this.addLabelShow = true;
    },
    changeWay() {
      this.addLabelForm.link = '';
    },
    // 删除轮播图
    deleteLabel(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定删除该标签吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteServicer, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getLabelList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    // 轮播
    handleLabel() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.httpPost(this.$root.addServicer, this.addLabelForm).then(
            (res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.loading--;
              this.addLabelShow = false;
              this.getLabelList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    changeSortModal() {
      // this.sortShow = true;
    },
    // 图片改变
    addChangeImg(e) {
      this.upPic(e, (res) => {
        this.$set(this.addLabelForm, 'pic', res);
        // 清空input value，解决重复图片不触发change
        this.$refs.inputImg.value = '';
        this.$refs.form.clearValidate(['pic']);
      });
    },
    // 上传图片
    upPic(e, fun) {
      // 上传图片
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      this.request.upPic({ prefix: 'other', file: file }).then(
        (res) => {
          fun(res);
        },
        (res) => {}
      );
    },
    saveSort() {}
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.label-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .top-box{
        flex-x();
        .title{
          word(18px, #333);
          font-weight: bold;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 30px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #40B98F;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        // margin-right: 8px;
        cancel-btn();
      }

      .table-img {
        height: 70px;
        width: auto;
      }
    }
  }

  .dialog-content {
    flex-y();
  }

  .addImg {
    .icon {
      width: 270px;
      height: 108px;
    }
  }

  .label-form {
    width: 400px;
    margin: 20px auto;

    .sort-tip {
      word(14px, #c8c8c8);
      line-height: 20px;
    }
  }
  .form-item{
    span{
      margin: 0 3px;
      word(14px, #666);
    }
  }
}
</style>
